<template>
  <page-edicion>
    <page-header title="Crear origen de oferta" back-to="/origenOferta" />
    <formulario :origen-oferta="origenOferta" @submit="insertar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import origenOfertaApi from "@/services/origenOferta.js";

export default {
  components: { Formulario },
  data() {
    return {
      origenOferta: origenOfertaApi.crear(),
    };
  },
  methods: {
    insertar() {
      origenOfertaApi.insertar(this.origenOferta).then(() => {
        this.$messages.success("Se ha creado el registro de origen oferta");
        this.$router.push({ path: "/origenOferta" });
      });
    },
  },
};
</script>
